import { IonButton } from "@ionic/react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import WithNavigation from "../../hoc/with-navigation";
import { useSystem } from "../../store/system";

import "./styles.css";

const System = () => {
	const { id } = useParams() as any;
	const history = useHistory();

	const systemStore = useSystem();

	useEffect(() => {
		systemStore.get(id);
	}, []);

	return (
		<WithNavigation preventGoBack={false} text={systemStore.system?.name || ""}>
			<div className="actions">
				<IonButton
					id="confirm-key-button"
					className="system-view-btn"
					expand="block"
					color="dark"
					fill="clear"
					onClick={() => history.push(`/system/${id}/propulsion`)}
					disabled={false}
				>
					<span className="btn-label">Propulsión</span>
				</IonButton>
				<IonButton
					id="confirm-key-button"
					className="system-view-btn"
					expand="block"
					color="dark"
					fill="clear"
					onClick={() => history.push(`/system/${id}/tow-cable`)}
					disabled={false}
				>
					<span className="btn-label">Cables de arrastre</span>
				</IonButton>
				<IonButton
					id="confirm-key-button"
					className="system-view-btn"
					expand="block"
					color="dark"
					fill="clear"
					onClick={() => history.push(`/system/${id}/guinches`)}
					disabled={false}
				>
					<span className="btn-label">Guinches</span>
				</IonButton>
				<IonButton
					id="confirm-key-button"
					className="system-view-btn"
					expand="block"
					color="dark"
					fill="clear"
					onClick={() => history.push(`/system/${id}/trawl-gates`)}
					disabled={false}
				>
					<span className="btn-label">Puertas</span>
				</IonButton>
				<IonButton
					id="confirm-key-button"
					className="system-view-btn"
					expand="block"
					color="dark"
					fill="clear"
					onClick={() => history.push(`/system/${id}/trawl-systems`)}
					disabled={false}
				>
					<span className="btn-label">Sistemas de arrastre</span>
				</IonButton>
				<IonButton
					id="confirm-key-button"
					className="system-view-btn"
					expand="block"
					color="dark"
					fill="clear"
					onClick={() => history.push(`/system/${id}/flotation`)}
					disabled={false}
				>
					<span className="btn-label">Flotación y Lastre</span>
				</IonButton>
				<IonButton
					id="confirm-key-button"
					className="system-view-btn"
					expand="block"
					color="dark"
					fill="clear"
					onClick={() => history.push(`/system/${id}/cloths`)}
					disabled={false}
				>
					<span className="btn-label">Paños</span>
				</IonButton>
				<IonButton
					id="confirm-key-button"
					className="system-view-btn"
					expand="block"
					color="dark"
					fill="clear"
					onClick={() => history.push(`/faq`)}
					disabled={false}
				>
					<span className="btn-label">Preguntas frecuentes</span>
				</IonButton>
			</div>
			<div className="logo-container">
				<img src="/assets/powered-by.png" alt="Powered by Acruxsoft" />
			</div>
		</WithNavigation>
	);
};

export default System;
